module.exports = __webpack_public_path__ + "assets/img/thumb-Webprofits-2021-Video-Services-Showreel-Video.46e0a640.jpg";